import { useCapability } from '@/features/permissions/hooks'
import { useConfiguration } from './useConfiguration'

/**
 * Returns whether the signed-in user may use Snippets.
 *
 * The single read site for the gate — the route, the sidebar link and the
 * editor all go through here.
 *
 * Two boundaries, both required. `features.snippets` is the rollout control:
 * whether this organization has snippets at all. `snippets.view` is which
 * roles inside it may use them.
 */
export function useSnippetsEnabled(): boolean {
  const { configuration, isPreviousOrgData } = useConfiguration()
  const permitted = useCapability('snippets.view') === true
  // During an org switch the config query serves the previous org's data under
  // the new org's id, so trusting it would carry one org's rollout into another.
  if (isPreviousOrgData) return false
  return permitted && (configuration?.features?.snippets ?? false)
}
